import React, { useEffect } from 'react';
import { ApolloClient, ApolloProvider, InMemoryCache, HttpLink, split } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { WebSocketLink } from '@apollo/client/link/ws';
import { getMainDefinition } from '@apollo/client/utilities';

export const logoutListeners = [];

const httpLink = new HttpLink({ uri: '/graphql', credentials: 'include' });
const logoutLink = onError(({ networkError }) => {
	console.log('Encountered network error: ', networkError);
	if (networkError != null && 'statusCode' in networkError && networkError.statusCode == 401) logoutListeners.forEach(fn => fn());
});

// Websocket stuff
const protocol = window.location.protocol.includes('https') ? 'wss' : 'ws';
export const wsLink = new WebSocketLink({
	uri: protocol + (window.location.host.indexOf('localhost') > -1 ? '://' + window.location.host.split(':')[0] + ':5000/subscriptions' : '://' + window.location.host + '/subscriptions'),
	options: {
		reconnectionAttempts: Infinity,
		reconnect: true,
	},
});

// Combined HTTP / websocket stuff
const splitLink = split(
	({ query }) => {
		const definition = getMainDefinition(query);
		return (
			definition.kind === 'OperationDefinition' &&
			definition.operation === 'subscription'
		);
	},
	wsLink,
	logoutLink.concat(httpLink),
);


export const myApolloClient = new ApolloClient({
	uri: '/graphql',
	cache: new InMemoryCache(),
	defaultOptions: {
		watchQuery: {
			fetchPolicy: 'network-only',
			errorPolicy: 'ignore',
		},
		query: {
			fetchPolicy: 'network-only',
			errorPolicy: 'all',
		},
	},
	link: logoutLink.concat(splitLink),
});

export function ApolloInjector({ children }) {
	return <ApolloProvider client={myApolloClient}>
		{children}
	</ApolloProvider>;
}
